/**
 * 关系确认邀请
 * */
import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import { Modal, Button } from 'antd';
import { connect } from 'react-redux';
import './common.scss';
import { DDLoading } from '../globalPageStatus';
import { _change_affinity_modal } from '../../../src/store/Action';
import Util from '../../script/util';

class AffinityConfirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      loading: false,
      typeInfo: {},
      tokenInfo: {},
      otherInfo: {},
    };
  }

  showModal = ({ typeInfo, tokenInfo, otherInfo }) => {
    this.setState({
      visible: true,
      typeInfo,
      tokenInfo,
      otherInfo,
    });
  };
  hideModal = () => {
    this.setState({
      visible: false,
    });
  };

  onSubmit = () => {
    const {
      base: { userInfo },
    } = this.props;
    const { typeInfo, tokenInfo, otherInfo } = this.state;
    let detail = {
      giftId: tokenInfo.propGoodsId,
      giftIdType: tokenInfo.intimateType,
      giftName: tokenInfo.goodsName,
      inviterAvatar: userInfo.avatar,
      inviterNickName: userInfo.nickName,
      inviterUid: userInfo.uid,
      receiveAvatar: otherInfo.avatar,
      receiveNickName: otherInfo.nickName,
      receiveUid: otherInfo.uid,
      staticPic: tokenInfo.prePic,
      status: 0,
      relationConfigName: typeInfo.name,
      relationConfigId: typeInfo.relationConfigId,
      invitationIcon: typeInfo.invitationIcon,
      mallSkuId: tokenInfo.mallSkuId,
      skuPrice: tokenInfo.skuPrice,
    };
    _change_affinity_modal({
      affinityApplyModal: true,
      affinityApplyDetail: detail,
    });
    this.hideModal();
  };

  render() {
    const { loading, typeInfo, otherInfo, tokenInfo, visible } = this.state;
    return (
      <div className="affinity-modal">
        <Modal
          open={visible}
          zIndex={1004}
          wrapClassName="daidai-modal-style has-top-border"
          centered={true}
          title={`确认邀请`}
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="400px"
          onCancel={this.hideModal}
        >
          <DDLoading status={loading} className="set-plan-spin">
            <div className="affinity-modal-box" style={{ height: '468px' }}>
              <div
                className="token-box"
                style={{
                  backgroundImage: `url(${Util.transImgUrl(tokenInfo.backgroundPic)})`,
                }}
              >
                {tokenInfo?.rarityConfig ? (
                  <div className="rarity">
                    <img
                      src={Util.transImgUrl(tokenInfo?.rarityConfig?.labelImg)}
                      alt=""
                    />
                  </div>
                ) : null}
                <img
                  src={Util.transImgUrl(tokenInfo.prePic, '150x150')}
                  alt=""
                />
              </div>
              <h3>{tokenInfo?.goodsName}</h3>
              <div className="token-name">
                <span>邀请</span>
                <div className="token-avatar">
                  <img
                    src={Util.transImgUrl(otherInfo?.avatar, '50x50')}
                    alt=""
                  />
                </div>
                <span>{otherInfo?.otherNickName} 和你成为</span>
                <div className="token-icon">
                  <img
                    src={Util.transImgUrl(
                      typeInfo?.relationConfigIcon,
                      '50x50'
                    )}
                    alt=""
                  />
                </div>
                <span style={{ color: '#FF4279' }}>
                  {typeInfo?.relationConfigName}
                </span>
              </div>
              <h5>{tokenInfo?.goodsRemark}</h5>
              <h5>{tokenInfo?.otherTip}</h5>
              <div className="diamond-box">
                {tokenInfo.intimateType != 0 ? (
                  <div className="diamond-cell active">
                    <i className="icon icon-diamond"></i>
                    {tokenInfo?.skuPrice}
                  </div>
                ) : null}
              </div>
              <div className="affinity-row">
                <Button
                  className="daidai-btn-primary"
                  style={{ width: '252px' }}
                  onClick={this.onSubmit}
                >
                  确认邀请
                </Button>
              </div>
            </div>
          </DDLoading>
        </Modal>
      </div>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(AffinityConfirm, { withRef: true })
);
